import { render, staticRenderFns } from "./HbSpaceIcon.vue?vue&type=template&id=0fb865bc&scoped=true&"
import script from "./HbSpaceIcon.vue?vue&type=script&lang=js&"
export * from "./HbSpaceIcon.vue?vue&type=script&lang=js&"
import style0 from "./HbSpaceIcon.vue?vue&type=style&index=0&id=0fb865bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb865bc",
  null
  
)

export default component.exports